<template>
  <div class="page">
    <my-header :breadcrumb="breadcrumb"></my-header>
    <div class="content">
      <div class="content-wrap">
        <el-table
            :data="tableData"
            :default-sort="{prop: 'id', order: 'descending'}"
        >
          <el-table-column
              prop="id"
              label="ID"
              sortable
          >
          </el-table-column>
          <el-table-column
              prop="type_name"
              label="类型"
          >
          </el-table-column>
          <el-table-column
              prop="mobile"
              label="电话"

          >
          </el-table-column>
          <el-table-column
              prop="hangye"
              label="所属行业"

          >
          </el-table-column>
          <el-table-column
              prop="platform"
              label="账户平台"

          >
          </el-table-column>
          <el-table-column
              prop="content"
              label="内容"
              sortable
          >
          </el-table-column>
          <el-table-column
              prop="addTimeText"
              label="添加时间">
          </el-table-column>

          <el-table-column
              label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">未联系</span>
              <span v-else-if="scope.row.status == 2">已联系</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
              <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="totalCount" :page-size="10" class="pagination" @current-change="changePage">
        </el-pagination>
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <el-form-item label="姓名" :label-width="formLabelWidth">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth">
              <el-input v-model="form.mobile"></el-input>
            </el-form-item>
            <el-form-item label="内容" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="form.content"></el-input>
            </el-form-item>
            <el-form-item label="状态" :label-width="formLabelWidth">
              <el-switch
                  v-model="form.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949" :active-value="2"
                  :inactive-value="1" active-text="已联系"
                  inactive-text="未联系">
              </el-switch>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="clickConfirm">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from "../header";
import Cookies from "js-cookie"
export default {
  name: "List",
  components: {
    MyHeader
  },
  data() {
    return {
      form: {
        parentName:'',
        typeName:'',
        moduleName:''
      },
      formLabelWidth:'120px',
      tableData: [],
      totalCount: 0,
      pageCount: 1,
      breadcrumb: [
        {
          name: '留言管理'
        },
        {
          name: '留言列表'
        }
      ],
      dialogFormVisible:false,
      arrType:[
        {label:'内部模块',value:1},
        {label:'外部链接',value:2}
      ],
      arrModule:[
        {label:'文章模块',value:1}
      ],
      showModule:false,
      showLink:false,
      dialogTitle:'编辑留言',
      categoryList:[],
      parentList:[],
      page:1
    }
  },
  created(){
    this.form.id = this.$route.query.id;
    this.getList(this.page);
  },
  methods:{
    getList(page){
      this.$http.get(this.apiUrl+'/v1/guestbook/list',{params:{page:page}}).then(({data})=>{
        this.tableData = data.result.list;
        this.totalCount = parseInt(data.result.totalCount)
      })
    },
    changePage(val){
      this.page += 1;
      this.getList(this.page)
    },
    clickAdd(){
      this.$router.push('/admin/article/edit')
    },
    clickConfirm(){
      this.$http.post('/v1/guestbook/save',this.form).then(({data})=>{
        if (data.errcode == 0){
          this.$message.success(data.msg);
          this.dialogFormVisible = false;
          this.getList();
        }else{
          this.$message.error(data.msg);
        }
      })
    },
    handleEdit(index,row){
      this.dialogFormVisible = true;
      this.$http.get(this.apiUrl+'/v1/guestbook/view',{params:{id:row.id}}).then(({data})=>{
        if (data.errcode == 0){
          this.form = data.result;
        }

      })
    },
    handleDelete(index,row){
      this.$confirm('确定要删除吗？删除之后数据不可恢复').then(()=>{
        this.$http.delete('/v1/guestbook/delete',{data:{id:row.id}}).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg)
            this.getList();
          }else{
            this.$message.error(data.msg)
          }
        })
      })
    },
    changeType(val){
      this.form.type = val;
      if (val == 1){
        this.showModule = true;
        this.showLink = false;

      }else {
        this.showLink = true;
        this.showModule = false;
        this.form.module_id = 0;
      }
    },
    changeModule(val){
      this.form.module_id = val;
      if (val == 1){
        this.$http.get('/v1/acategory/list?siteId='+Cookies.get('siteId')).then(({data}) => {
          this.categoryList = data.result;
        })
      }

    },
    changeCate(val){
      var _this = this;
      this.form.category_id = val;
      if (!this.form.nav_id){
        this.categoryList.forEach(function (item) {
          if(item.cate_id == val){
            _this.form.title =  item.cate_name;
          }
        })
      }

    },
    changeParent(val){
      var _this = this;
      this.form.parent_id  = val;
      this.tableData.forEach(function (item) {
        if (item.nav_id == val){
          _this.form.parentName = item.title;
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
